import angular from 'angular';
import selectRadio from './selectRadio';

export default angular
  .module('components.selectRadio', [])
  .component('selectRadio', selectRadio).name;
